import React, { useEffect, useRef } from 'react';

import { useStyles } from './style';
import { useConnectStripeMutation, useGetStripeLoginLinkMutation, useMeQuery } from '../../../../api/user';
import stripeLogo from '../../../../assets/images/stripeLogo.png';
import { useHistory, useLocation } from 'react-router-dom';

export const SupplierStripe: React.FC = () => {
  const classes = useStyles();
  const { search } = useLocation();
  const { replace } = useHistory();
  const code = search.split('code=')[1];
  const { data: user } = useMeQuery();
  const [getLoginLink] = useGetStripeLoginLinkMutation();
  const stripeLink = useRef<HTMLAnchorElement | null>(null);
  
  const isStripeConnected = user && 'stripe_user_id' in user && user?.stripe_user_id;
  const [connectStripe] = useConnectStripeMutation();

  useEffect(() => {
    code &&
      connectStripe(code).then(() => {
        replace('/account/billing/plans/stripe');
      });
  }, [code]);

  const onLoginStripe = () => {
    getLoginLink().then((res) => {
      if ('data' in res && res.data.success && res.data.login_link && stripeLink?.current) {
        stripeLink.current!.href = res.data.login_link;
        stripeLink.current!.click();
      }
    });
  };

  return (
    <div className={classes.supplierPmBox}>
      {isStripeConnected ? (
        <>
          <div className={classes.stripeTitle}>Your account is set up to receive credit card payments</div>
          <div className={classes.stripeSubText}>To edit your banking details please log into stripe</div>
          <div className={classes.loginStripBtn} onClick={onLoginStripe}>
            <img src={stripeLogo} alt='Stripe login' width={26} height={32} />
            <span>Stripe Login</span>
          </div>
        </>
      ) : (
        <>
          <div className={classes.stripeTitle}>Connect Stripe Account</div>
          <div className={classes.stripeSubText}>Connect Your Stripe Account for Easy Customer Payments Processing!</div>
          <a
            href={`https://connect.stripe.com/express/oauth/authorize?redirect_uri=${process.env.REACT_APP_STRIPE_EXPRESS_REDIRECT_URI}&client_id=${process.env.REACT_APP_STRIPE_CLIENT_ID}&stripe_user[email]=${user?.email}&stripe_user[first_name]=${user?.first_name}&stripe_user[last_name]=${user?.last_name}&stripe_user[business_name]=${user?.company?.name}`}
            className={classes.connectStripBtn}
          >
            Connect with Stripe
          </a>
        </>
      )}
      <a href='' className={classes.hiddenLink} target='_blank' ref={stripeLink} />
    </div>
  );
};
